// @flow
import React, { Component } from 'react';
import Dropdown from '@localytics/loc-components/lib/Dropdown';
import Button from '@localytics/loc-components/lib/Button';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import './ChooseEntryEventPage.scss';
import { createNewOrchAndVersion } from './actions/chainedApi';
import { chooseEntryEvent } from './actions/wip';
import AppGroupHeader from './components/AppGroupHeader';
import { getQueryParams } from './util/RouterUtils';

type Props = {
  eventMappings: Array<Object>,
  dispatch: Function,
  orchestrationName: string,
  appGroupsById: Array<Object>, // TODO: this is wrong
  eventMappings: Array<Object>,
  eventMappingsById: Array<Object>, // TODO and this
  appGroup: number,
  orgId: number,
  history: Object
};

type Option = {
  label: string,
  value: number
};

type State = {
  selectedValue: Option | null
};

class ChooseEntryEventPage extends Component<Props, State> {
  state = { selectedValue: null };

  componentDidMount: Function = () => {
    const { dropdown } = this;
    if (dropdown) {
      dropdown.getElementsByClassName('Select-input')[0].focus();
    }
  };

  componentDidUpdate: Function = (prevProps, prevState) => {
    const { button } = this;
    const { selectedValue: currentValue } = this.state;
    const { selectedValue: prevValue } = prevState;
    if (button && currentValue !== prevValue) {
      button.getElementsByTagName('button')[0].focus();
    }
  };

  setValue: Function = (option: { label: string, value: number }) => {
    this.setState({ selectedValue: option });
  };

  button: ?HTMLDivElement;
  dropdown: ?HTMLDivElement;

  submitValue: Function = () => {
    const { selectedValue } = this.state;
    // This makes flow happy :/ but the submit isn't allowed until a value is selected
    if (!selectedValue) {
      return;
    }
    const eventMappingId = selectedValue.value;
    this.props.dispatch(chooseEntryEvent(eventMappingId));

    const appGroupData = this.props.appGroupsById[this.props.appGroup];
    const { id: appGroupId } = appGroupData;
    const apps = appGroupData.apps.map(g => ({
      app_uuid: g.id,
      olap_id: g.olap_id
    }));
    const entryEventData = this.props.eventMappingsById[eventMappingId];
    const events = entryEventData.events.map(e => ({
      name: e.name,
      olap_id: e.olap_id
    }));

    this.props.dispatch(
      createNewOrchAndVersion(
        this.props.history,
        this.props.orgId,
        this.props.orchestrationName,
        appGroupId,
        apps,
        events,
        eventMappingId
      )
    );
  };

  render() {
    const { eventMappings, orchestrationName } = this.props;

    const appGroup = this.props.appGroupsById[this.props.appGroup];
    let isLoading = false;
    let options = [];
    if (eventMappings) {
      const appGroupAppIds = appGroup.apps.map(a => a.id);

      const eventApps = eventMappings.filter(em =>
        appGroupAppIds.every(appId =>
          em.events.map(ev => ev.app_id).includes(appId)
        )
      );

      options = eventApps
        .map(group => ({
          label: group.name,
          value: group.id
        }))
        .sort((optionA, optionB) => optionA.label.localeCompare(optionB.label));
    } else {
      isLoading = true;
    }

    return (
      <div className="Page__Body">
        <div className="Page__Header">
          <div className="Page__Header__Title">{orchestrationName}</div>
        </div>
        <AppGroupHeader appGroupName={appGroup.name} apps={appGroup.apps} />
        <div
          className="Page__Content Page__Content--flexible"
          style={{ paddingBottom: '150px' }}
        >
          <div className="ChooseEntryEventPage">
            <h6>WORKFLOW SETUP</h6>
            <h1>Select Entry Event</h1>
            <div className="ChooseEntryEventPage__Body">
              <p>
                Select an event that you want users to perform before entering
                into this workflow. This is required to trigger a workflow.
              </p>
              <div
                className="ChooseEntryEventPage__Dropdown"
                ref={dropdown => {
                  this.dropdown = dropdown;
                }}
              >
                <Dropdown
                  name="EventMapping"
                  options={options}
                  selectedValue={this.state.selectedValue}
                  onSelect={this.setValue}
                  clearable={false}
                  onSubmit={this.submitValue}
                  isLoading={isLoading}
                />
              </div>
              <div
                className="ChooseEntryEventPage__Button"
                ref={button => {
                  this.button = button;
                }}
              >
                <Button
                  type="primary"
                  label="Create Workflow"
                  onClick={this.submitValue}
                  disabled={!this.state.selectedValue}
                />
              </div>
              <span className="ChooseEntryEventPage__EnterToContinue">
                Hit <span>↵ Enter</span> to continue
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { orgId } = getQueryParams(ownProps.location);
  return {
    orgId,
    eventMappings: state.railsApi.eventMappings,
    eventMappingsById: state.railsApi.eventMappingsById,
    appGroupsById: state.railsApi.appGroupsById,
    orchestrationName: state.wip.orchestrationName,
    appGroup: state.wip.appGroup
  };
};

export default withRouter(connect(mapStateToProps)(ChooseEntryEventPage));



// WEBPACK FOOTER //
// ./src/ChooseEntryEventPage.jsx